import Swiper from "swiper";
import { Autoplay, EffectFade, FreeMode, Navigation, Pagination, Scrollbar, Thumbs } from "swiper/modules";

export const Slider = (config) => ({
  config,
  slider: null,
  loaded: false,

  init () {
    this.config.modules = [Autoplay, EffectFade, FreeMode, Navigation, Pagination, Scrollbar, Thumbs];
    this.slider = new Swiper(this.$el, this.config);
    this.loaded = true
  }
});
